const EmailPreview = ({ form }) => {
    if (!form?.body) return <p className='italic text-gray-500'>No content to preview.</p>

    return (
        <div className='p-4 space-y-4 bg-white border border-gray-300 rounded shadow'>
            <h2 className='text-xl font-semibold'>{form.subject || 'Untitled Email'}</h2>
            <div className='prose max-w-none' dangerouslySetInnerHTML={{ __html: form.body }} />
        </div>
    )
}

export default EmailPreview
